import { ChangeDetectorRef, Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemService } from '@services/item.service';
import { MessageService } from '@services/message.service';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { WebErrorService } from '@services/webError.service';
import { Subject, Subscription } from 'rxjs';
import { CreateNewItemComponent } from 'src/app/items/create-new-item/create-new-item.component';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { FlipitemtabService } from '../../services/flipitemtab.service';
import { AddInstructionsDialogboxComponent } from '../add-instructions-dialogbox/add-instructions-dialogbox.component';
import { InstructionDialogReadonlyComponent } from '../instruction-dialog-readonly/instruction-dialog-readonly.component';
import { TestPreviewComponent } from '../test-preview/test-preview.component';
import { ScoringTypeEnum, ScoringTypeName1, ScoringTypeNameEnum } from 'src/app/shared/config/questions.config';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-tests-items',
  templateUrl: './tests-items.component.html',
  styleUrls: ['./tests-items.component.scss']
})


export class TestsItemsComponent implements OnDestroy {
  @Input() isPublished: boolean;
  @Input() tabData: any;
  testDetailData: any;
  testServiceSubscription: Subscription;
  testDetailSubscription: Subscription;
  testStatusSubscription: Subscription;
  flipItemSubscription: Subscription;
  itemlistSubscription: Subscription;
  testUUID: any;
  currentIdBackup: string;
  displayedColumns: string[] = ['itemBankName', 'itemGroup', 'scoringType', 'itemStatus', 'updated', 'tags', 'action'];
  totalRecords: any;
  searchText: any;
  page: number = 1;
  itemName = "";
  itemDescription = "";
  itemStatus = "";
  isItemDescended = true;
  messageFlag = false;
  success = false;
  error = false;
  messages = '';
  items: any;
  itemId: any;
  isNoItem = true;
  dialogBoxData: any;
  globalcollectionid: any;
  collectionId: any;
  itemBankName: any;
  globalcollectionuuid: any;
  isTestPublish: string;
  dialogRef$: any;
  existingItemList = false;
  routeSubscription: Subscription;
  exitingItemData: any;
  displayItemGroups: boolean = false;
  defaultItemGroupDetails: any;
  previewData: any;
  displayItemGroup: Array<number> = [];
  itemGroupList: Array<any> = [];
  activeItemGroupId: number;
  itemGroupOnExisting: Array<any> = [];
  selectedItemGroup: any;
  allItemGroupList: any;
  @ViewChild('table') table: MatTable<any>;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  ScoringTypeNameEnum = ScoringTypeNameEnum;
  ScoringTypeName1 = ScoringTypeName1;
  @ViewChild('appTestPreview', { static: true }) appTestPreview: TestPreviewComponent;
  @Input()
  get pageIndex(): number { return this._pageIndex; }
  set pageIndex(pageIndex: number) {
    this._pageIndex = pageIndex;
    this._changeDetectorRef.markForCheck();
  }
  _pageIndex: number = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator, { static: false }) set content(paginator: MatPaginator) {
    if (this.matTableDataSource) {
      this.matTableDataSource.paginator = paginator;
    }
  }
  private unsubscribe: Subject<void> = new Subject<void>();
  showPaginator = false;
  langCode : string;
  isItemAddedFromTest : boolean = false;
  constructor(
    private testService: TestService,
    private router: Router,
    private actRoute: ActivatedRoute,
    private flipitemtabService: FlipitemtabService,
    private dialog: MatDialog,
    private messageService: MessageService,
    private itemservice: ItemService,
    private webErrorService: WebErrorService,
    private notificationServices: NotificationService,
    public roleSer: RoleManagementService,
    private _changeDetectorRef: ChangeDetectorRef,
    public translate: TranslateService
  ) {
    this.testService.isTestItemCount.subscribe(istestcount => {
      this.tablePageConfig.length = istestcount;
    });
    this.langCode = localStorage.getItem('language');
  }

  @Input() set testDetails(data: any) {
    if (!!data) {
      this.testDetailData = data.data;
      this.testUUID = this.actRoute.snapshot.paramMap.get('id');
      if (this.testDetailData && this.testDetailData.lstItemCategoryMaster?.length) {
        let gList = this.testDetailData.lstItemCategoryMaster.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
        gList.push(gList.splice(0, 1)[0])

        this.itemGroupList = gList;
        this.allItemGroupList = (gList.length === 1) ? gList.find(d => d.itemCategoryName != 'Others') : gList;
        console.log(this.allItemGroupList);
        this.activeItemGroupId = this.itemGroupList.find(d => d.itemCategoryName != 'Others')?.itemCategoryid;
        if (sessionStorage.getItem('itemCategoryID') != undefined) {
          this.activeItemGroupId = parseInt(sessionStorage.getItem('itemCategoryID'))
        }
        this.selectedItemGroup = this.itemGroupList.find(d => d.itemCategoryName != 'Others');
      }

      if (!this.currentIdBackup || this.currentIdBackup !== this.testUUID) {
        this.currentIdBackup = this.testUUID;
        if (this.testDetailData) {
          this.isTestPublish = this.testDetailData.statusName;
        }

        this.isPublished = false;
        this.getItems();
        this.assignAndCreateOrder(data.data, true);
        this.preparePagination(true);
        this.messageService.getMessageNext().subscribe(data => {
          this.messageFlag = true;
          this.success = true;
          this.error = false;
          this.messages = data?.text;
        },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error);
          });

        if (this.flipItemSubscription) { this.flipItemSubscription.unsubscribe(); }
        this.flipItemSubscription = this.flipitemtabService.on<boolean>().subscribe(data => {
          this.existingItemList = data;
          this.isItemAddedFromTest = data;
          // this.resetDataItemsByTestId();
          this.getItems();

        });

        if (this.testStatusSubscription) { this.testStatusSubscription.unsubscribe(); }
        this.testStatusSubscription = this.testService.updateTestStatus
          .subscribe(isTestDisabled => this.isPublished = isTestDisabled);
      }
    } else {
      this.isNoItem = true;
    }
  }

  getItems(): void {
    this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
      (resData1) => {
        const testDetailSubscription = this.testService.getTestDetails(this.testUUID).subscribe(
          resData => {
            this.testDetailData = resData.data;
            if (this.testDetailData && this.testDetailData.lstItemCategoryMaster?.length) {
              let gList = this.testDetailData.lstItemCategoryMaster.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
              gList.push(gList.splice(0, 1)[0])
              this.itemGroupList = gList;
              this.allItemGroupList = (gList.length === 1) ? gList.find(d => d.itemCategoryName != 'Others') : gList;
              console.log(this.allItemGroupList);
              this.activeItemGroupId = this.itemGroupList.find(d => d.itemCategoryName != 'Others')?.itemCategoryid;
              if (sessionStorage.getItem('itemCategoryID') != undefined) {
                this.activeItemGroupId = parseInt(sessionStorage.getItem('itemCategoryID'))
              }
              this.selectedItemGroup = this.itemGroupList.find(d => d.itemCategoryName != 'Others');
            }
            testDetailSubscription.unsubscribe();
            this.testService.isTestItemCount.next(resData1.data.length);
            if (resData1.data.length) {
              this.assignAndCreateOrder(resData1.data, true);
              this.preparePagination(true);
            }
          });
      },
      (error) => { this.isNoItem = true; this.webErrorService.handleAPIErrors(error); },
      () => this.testServiceSubscription.unsubscribe()
    )
  }

  deleteItemFromTest(testBankuuId: number, itemBankuuId: number, itemBankName: any) {
    this.testService.deleteItemFromTest(testBankuuId, itemBankuuId).subscribe(resData => {
      this.notificationServices.success(resData.message);
      this.resetDataItemsByTestId();

      this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
        (data) => {
          this.assignAndCreateOrder(data.data, true);
          this.preparePagination(true);
        },
        (error) => this.webErrorService.handleAPIErrors(error),
        () => this.testServiceSubscription.unsubscribe()) || undefined;
    },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });
  }

  openConfirmationDialog(row: any) {
    if(!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)){
      const dialogRef = this.dialog.open(DelMessageComponent, {
        data: {
          message: this.translate.instant('testId.TabItems.deletePopup.message'),
          buttonText: {
            ok: this.translate.instant('testId.TabItems.deletePopup.btnYes'),
            cancel: this.translate.instant('testId.TabItems.deletePopup.btnNo')
          }
        }
      });
      const dialogSubscription = dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.deleteItemFromTest(row.testBankuuId, row.itemBankuuId, row.itemBankName);
        }
        dialogSubscription.unsubscribe();
      });
    };
  }

  openInstructionDialog(row) {
    if(!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)){
      if (this.isTestPublish == "Unpublished") {
        const dialogRef = this.dialog.open(AddInstructionsDialogboxComponent, {
          width: '800px',
          panelClass: 'add-instruction-container',
          data: row
        });
        const dialogSubscription: Subscription = dialogRef.afterClosed().subscribe(() => {
          this.afterCloseSetting(this.selectedItemGroup, false);
          dialogSubscription.unsubscribe();
        });
      }

      if (this.isTestPublish == "Published") {
        this.dialog.open(InstructionDialogReadonlyComponent, {
          width: '800px',
          panelClass: 'add-instruction-container',
          data: row
        });
      }
    };
  }

  afterCloseSetting(selectedItemGroup, isTrue) {
    this.itemlistSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
      (resData1) => {
        let filterdData: any;
          this.displayItemGroup = resData1.data.map((item) => item.itemGroupId).filter((item, index, currentVal) => currentVal.indexOf(item) === index);
          if (selectedItemGroup != undefined ) filterdData = resData1.data.filter(d => d.itemGroupName === selectedItemGroup.itemCategoryName);
          const testDetailSubscription = this.testService.getTestDetails(this.testUUID).subscribe(
            resData => {
              this.testDetailData = resData.data;
              if (this.testDetailData && this.testDetailData.lstItemCategoryMaster?.length) {
                this.itemGroupList = this.testDetailData.lstItemCategoryMaster.sort((a, b) => (a.itemCategoryOrderToRender - b.itemCategoryOrderToRender));
                this.itemGroupList.push(this.itemGroupList.splice(0, 1)[0])
                if(filterdData != undefined && filterdData.length == 0) {
                  this.displayItemGroup = resData1.data.map((item) => item.itemGroupId).filter((item, index, currentVal) => currentVal.indexOf(item) === index);
                  this.activeItemGroupId = this.displayItemGroup ? this.displayItemGroup.length == 1 ? this.displayItemGroup[0] : this.itemGroupList.find(d => this.displayItemGroup.includes(d.itemCategoryid) && d.itemCategoryName != 'Others')?.itemCategoryid : 0;
                  if (this.activeItemGroupId == undefined) this.activeItemGroupId = this.selectedItemGroup.itemCategoryid;

                  if (this.displayItemGroup.length > 0) this.selectedItemGroup = this.itemGroupList.find(d => this.displayItemGroup.includes(d.itemCategoryid) && d.itemCategoryName != 'Others');
                }
              }
              testDetailSubscription.unsubscribe();
              this.testService.isTestItemCount.next(resData1.data.length);
            this.assignAndCreateOrder(resData1.data, false);
            this.preparePagination(true);
            this.resetDataItemsByTestId();
          });
      },
      (error) => { this.isNoItem = true; this.webErrorService.handleAPIErrors(error); },
      () => this.itemlistSubscription.unsubscribe()
    )
  }

  resetDataItemsByTestId() {
    this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
      (resData) => {
        this.previewData = resData?.data;
        this.testService.isTestItemCount.next(resData?.data.length);
        if (resData?.data?.length == 0) {
          this.isNoItem = true;
          this.testService.isTestItemCount.next(0);
        } else {
          this.assignAndCreateOrder(resData?.data, false);
          this.preparePagination(true);
        }
      },
      (error) => this.webErrorService.handleAPIErrors(error),
      () => this.testServiceSubscription.unsubscribe()) || undefined;
  }

  selectItemGroup(item) {
    this.testService.getItemByTestId(this.testUUID).subscribe(data => {
      this.testService.isTestItemCount.next(data.data.length);
      this.matTableDataSource = new MatTableDataSource(data.data.filter(d => d.itemGroupName === item.itemCategoryName));
      this.prepareItemGroups(this.matTableDataSource.filteredData);
      this.matTableDataSource = new MatTableDataSource(this.tableDataSource);
    });
    this.selectedItemGroup = item;
    return this.activeItemGroupId = item.itemCategoryid;
  }

  prepareItemGroups(data: any) {
    this.assignAndCreateOrder(data, false);
    this.preparePagination(false);
  }

  navigateToTestDetails(id: any) {
    this.router.navigate(["/tests-details", id]);
  }

  closeExistingItem() {
    this.existingItemList = false;
    // this.getItems();
    if (this.selectedItemGroup != undefined) this.activeItemGroupId = this.selectedItemGroup.itemCategoryid;
    this.afterCloseSetting(this.selectedItemGroup, false);
  }

  closeItemGroup() {
    this.displayItemGroups = false;
    this.activeItemGroupId = null;
    this.getItems();
  }

  createNewItem(): void {
    if (!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)) {
      const dialogRef = this.dialog.open(CreateNewItemComponent, {
        minWidth: '650px',
        data: {
          TestId: this.testUUID, //sessionStorage.setItem('TestId', this.testUUID),
          itemCategoryID: (this.itemGroupList.length === 1) ? this.itemGroupList[0].itemCategoryid : this.selectedItemGroup.itemCategoryid, //sessionStorage.setItem('itemCategoryID', this.selectedItemGroup.itemCategoryid),
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        // if (result != "noitem") {
        if (result && result.success) {
          let collectionId = this.actRoute.parent.snapshot.paramMap.get('id');
          sessionStorage.setItem('TestId', this.testUUID);
          sessionStorage.setItem('itemCategoryID', (this.itemGroupList.length === 1) ? this.itemGroupList[0].itemCategoryid : this.selectedItemGroup.itemCategoryid);
          // this.router.navigate(['/collections/' + collectionId + '/tests/' + this.testUUID]);
          this.router.navigate(['./collections/' + collectionId + '/items'])
        }
      });
    };
  }

  openDialogPreview(): void {
    this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
      (resData) => {
        this.previewData = resData?.data;
        this.appTestPreview.showPopup({ name: this.previewData, testID: this.testUUID, itemGroupList: this.allItemGroupList });
      },
      (error) => this.webErrorService.handleAPIErrors(error),
      () => this.testServiceSubscription.unsubscribe()) || undefined;
    // this.dialog.open(TestPreviewComponent, { width: '1250px', height: '600px', panelClass: 'dialog-container', data: { name: this.matTableDataSource, testID: this.testUUID } });
  }

  //#region  [Ordering Part]
  public orderIndex: any[];
  private tableDataSource: any;
  public matTableDataSource: any;
  public reuseProp = {
    incomingIdProperty: 'itemId',
    incomingOrderProperty: 'itemOrdertoRender',
    saveIdProperty: 'itemid',
    saveOrderProperty: 'itembankordertorender',
    testBankId: 'testbankid',
    testBankDetailsId: 'testbankdetailsid'
  };

  public tablePageConfig = { length: 0, pageIndex: 0, pageSize: 10, previousPageIndex: 0 };

  public onPageChange(event: any) { this.tablePageConfig = event; }

  public dragAndDropEventHandler(event: any) {
    this.tableDataSource = this.tableDataSource.filter(d => d.itemGroupName === event.item.data.itemGroupName);
    this.orderIndex = this.orderIndex.filter(d => d.itemGroupId === event.item.data.itemGroupId);
    const prevIndex = this.tableDataSource.findIndex((d) => d.itemId === event.item.data.itemId);
    const indexToSet = (this.tablePageConfig.pageIndex * this.tablePageConfig.pageSize) + event.currentIndex;
    this.moveItemOrder(this.tableDataSource, prevIndex, indexToSet);
    this.moveItemOrder(this.orderIndex, prevIndex, indexToSet);
    this.recreateIndex(this.tableDataSource, this.reuseProp.incomingOrderProperty);
    this.recreateIndex(this.orderIndex, this.reuseProp.saveOrderProperty);
    this.preparePagination(false);
    this.saveOrderAPICall();
  }

  private assignAndCreateOrder(data: any[], isLoadItemGroup: boolean): void {
    this.orderIndex = [];
    this.tableDataSource = [];
    if (data && data.length) {
      if (isLoadItemGroup) {
        data.sort((a, b) => (a.itemGroupOrder < b.itemGroupOrder ? -1 : 1));
        this.displayItemGroup = data.map((item) => item.itemGroupId).filter((item, index, currentVal) => currentVal.indexOf(item) === index);
        this.activeItemGroupId = this.displayItemGroup ? this.displayItemGroup.length == 1 ? this.displayItemGroup[0] : this.itemGroupList.find(d => this.displayItemGroup.includes(d.itemCategoryid) && d.itemCategoryName != 'Others')?.itemCategoryid : 0;
        if (sessionStorage.getItem('itemCategoryID') != undefined) {
          this.activeItemGroupId = parseInt(sessionStorage.getItem('itemCategoryID'))
        }
        // this.selectedItemGroup = this.itemGroupList.find(d => this.displayItemGroup.includes(d.itemCategoryid));
        this.selectedItemGroup = (this.itemGroupList.length === 1) ? undefined : this.itemGroupList.find(d => this.displayItemGroup.includes(d.itemCategoryid));
      }
      const questionOrder = data.sort((a, b) => (a[this.reuseProp.incomingOrderProperty] < b[this.reuseProp.incomingOrderProperty] ? -1 : 1));
      questionOrder.forEach((item) => {
        this.orderIndex.push({
          [this.reuseProp.saveIdProperty]: item[this.reuseProp.incomingIdProperty],
          [this.reuseProp.saveOrderProperty]: item[this.reuseProp.incomingOrderProperty],
          [this.reuseProp.testBankId]: item.testId,
          [this.reuseProp.testBankDetailsId]: item.testbankdetailsid,
          itemGroupId: item.itemGroupId
        });
        this.tableDataSource.push(item);
      });
      this.recreateIndex(this.orderIndex, this.reuseProp.saveOrderProperty);

      sessionStorage.removeItem('itemCategoryID');
    }
  }

  private moveItemOrder(dataList: any[], fromIndex: number, toIndex: number): void {
    if (!this.isPublished) {
      var element = dataList[fromIndex];
      dataList.splice(fromIndex, 1);
      dataList.splice(toIndex, 0, element);
    }
  }

  private recreateIndex(dataList: any[], propertyToCreateIndex: string): void {
    dataList.forEach(item => item[propertyToCreateIndex] = dataList.indexOf(item) + 1);
  }

  //#endregion

  private saveOrderAPICall() {
    this.itemservice.itemOrder(this.testUUID, this.orderIndex).subscribe(() => {
      this.testServiceSubscription = this.testService.getItemByTestId(this.testUUID)?.subscribe(
        (resData) => {
          this.previewData = resData?.data;
        },
        (error) => this.webErrorService.handleAPIErrors(error),
        () => this.testServiceSubscription.unsubscribe()) || undefined;
    },
      (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });
  }

  private preparePagination(isTrue: boolean) {
    const defaultItemGroup = this.itemGroupList.filter(e => e.itemCategoryid === this.activeItemGroupId);
    if (defaultItemGroup.length > 0 && isTrue) {
      this.defaultItemGroupDetails = this.tableDataSource.filter(d => d.itemGroupId === defaultItemGroup[0].itemCategoryid);
      this.defaultItemGroupDetails = this.defaultItemGroupDetails.sort((a, b) => (a.itemOrdertoRender - b.itemOrdertoRender));
      this.matTableDataSource = new MatTableDataSource(this.defaultItemGroupDetails);
    } else {
      this.tableDataSource = this.tableDataSource.sort((a, b) => (a.itemOrdertoRender - b.itemOrdertoRender));
      this.matTableDataSource = new MatTableDataSource(this.tableDataSource);
    }
    this.tablePageConfig.length = this.tableDataSource?.length;


    if (this.tableDataSource.length == 0) {
      this.isNoItem = true;
    } else {
      this.isNoItem = false;
      this.matTableDataSource.sort = this.sort;
      if (this._pageIndex) { this._pageIndex = 0; }
      this._pageIndex = this.tablePageConfig.pageIndex;

      setTimeout(() => {
        this.matTableDataSource.paginator = this.paginator;
        this.showPaginator = true
        if(this.matTableDataSource.paginator) {
          // ------Set translation for pagination------
          this.translate.stream([
            'testId.TabItems.pagination.pageLabel',
            'testId.TabItems.pagination.firstPage',
            'testId.TabItems.pagination.lastPage',
            'testId.TabItems.pagination.nextPage',
            'testId.TabItems.pagination.prevPage'
          ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
              this.matTableDataSource.paginator._intl.itemsPerPageLabel = translation['testId.TabItems.pagination.pageLabel'];
              this.matTableDataSource.paginator._intl.firstPageLabel = translation['testId.TabItems.pagination.firstPage'];
              this.matTableDataSource.paginator._intl.lastPageLabel = translation['testId.TabItems.pagination.lastPage'];
              this.matTableDataSource.paginator._intl.nextPageLabel = translation['testId.TabItems.pagination.nextPage'];
              this.matTableDataSource.paginator._intl.previousPageLabel = translation['testId.TabItems.pagination.prevPage'];

              this.matTableDataSource.paginator._intl.changes.next();
          });
        }

        this.translate.stream('items.statusArray').pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
        });
      });

    }
  }

  goToItemGroups() {
    if (!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)) {
      this.displayItemGroups = true
    }
  }

  goToExistingItemList() {
    if (!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)) {
      this.existingItemList = true
    };
  }

  ngOnDestroy() {
    if (this.testDetailSubscription) { this.testDetailSubscription.unsubscribe(); }
    if (this.testServiceSubscription) { this.testServiceSubscription.unsubscribe(); }
    this.isPublished = null;

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}

